import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "pc_admin_token";

export const adminApi = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// ---- auth ----
export async function apiLogin(email, password) {
  const { data } = await adminApi.post("/auth/login", { email, password });
  if (data.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
  return data.user;
}
export async function apiMe() {
  const { data } = await adminApi.get("/auth/me");
  return data;
}
export async function apiLogout() {
  try { await adminApi.post("/auth/logout"); } catch (e) {}
  localStorage.removeItem(TOKEN_KEY);
}

// ---- overview ----
export async function getOverview() {
  const { data } = await adminApi.get("/admin/overview");
  return data;
}

// ---- priests ----
export async function getPriests() {
  const { data } = await adminApi.get("/admin/priests");
  return data.priests;
}
export const createPriest = (body) => adminApi.post("/admin/priests", body).then((r) => r.data);
export const updatePriest = (id, body) => adminApi.patch(`/admin/priests/${id}`, body).then((r) => r.data);
export const deletePriest = (id) => adminApi.delete(`/admin/priests/${id}`).then((r) => r.data);
export const importPriests = (rows) => adminApi.post("/admin/priests/import", rows).then((r) => r.data);

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e?.message || fallback;
}

// ---- analytics ----
export const getAnalytics = () => adminApi.get("/admin/analytics").then((r) => r.data);

// ---- sessions ----
export const getSessions = (contact) => adminApi.get("/admin/sessions", { params: contact ? { contact: true } : {} }).then((r) => r.data);
export const getSession = (id) => adminApi.get(`/admin/sessions/${id}`).then((r) => r.data);

// ---- customers ----
export const getCustomers = (q) => adminApi.get("/admin/customers", { params: q ? { q } : {} }).then((r) => r.data);
export const getCustomer = (id) => adminApi.get(`/admin/customers/${id}`).then((r) => r.data);
export const patchCustomer = (id, status) => adminApi.patch(`/admin/customers/${id}`, { status }).then((r) => r.data);

// ---- payments ----
export const getPayments = () => adminApi.get("/admin/payments").then((r) => r.data);

// ---- poojas CRUD ----
export const getPoojas = () => adminApi.get("/admin/poojas").then((r) => r.data.poojas);
export const createPooja = (b) => adminApi.post("/admin/poojas", b).then((r) => r.data);
export const updatePooja = (id, b) => adminApi.patch(`/admin/poojas/${id}`, b).then((r) => r.data);
export const deletePooja = (id) => adminApi.delete(`/admin/poojas/${id}`).then((r) => r.data);

// ---- content pages ----
export const getPages = () => adminApi.get("/admin/pages").then((r) => r.data.pages);
export const createPage = (b) => adminApi.post("/admin/pages", b).then((r) => r.data);
export const updatePage = (id, b) => adminApi.patch(`/admin/pages/${id}`, b).then((r) => r.data);
export const deletePage = (id) => adminApi.delete(`/admin/pages/${id}`).then((r) => r.data);

// ---- seo keywords ----
export const getKeywords = () => adminApi.get("/admin/keywords").then((r) => r.data.keywords);
export const createKeyword = (b) => adminApi.post("/admin/keywords", b).then((r) => r.data);
export const updateKeyword = (id, b) => adminApi.patch(`/admin/keywords/${id}`, b).then((r) => r.data);
export const deleteKeyword = (id) => adminApi.delete(`/admin/keywords/${id}`).then((r) => r.data);

// ---- location pages ----
export const getLocations = () => adminApi.get("/admin/location-pages").then((r) => r.data.locations);
export const createLocation = (b) => adminApi.post("/admin/location-pages", b).then((r) => r.data);
export const updateLocation = (id, b) => adminApi.patch(`/admin/location-pages/${id}`, b).then((r) => r.data);
export const deleteLocation = (id) => adminApi.delete(`/admin/location-pages/${id}`).then((r) => r.data);

// ---- configuration ----
export const getConfig = () => adminApi.get("/admin/config").then((r) => r.data);
export const patchConfig = (b) => adminApi.patch("/admin/config", b).then((r) => r.data);
export const changeAdminRole = (id, role) => adminApi.patch(`/admin/admins/${id}/role`, { role }).then((r) => r.data);

// ---- patashala students ----
export const getPatashalaEnrollments = () => adminApi.get("/admin/patashala-enrollments").then((r) => r.data);
export const patchPatashalaEnrollment = (id, status) => adminApi.patch(`/admin/patashala-enrollments/${id}`, { status }).then((r) => r.data);
export const getPatashalaFileUrl = async (fileId) => {
  const res = await adminApi.get(`/admin/patashala-files/${fileId}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};
